
define('template!webshopAttributesEditView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="names">\n    <div class="libelle">' +
((__t = ( _.i18n('common.name', null, 'Name') )) == null ? '' : __t) +
'</div>\n    ';
 _.each(languages, function (l) { ;
__p += '\n    <div class="name-row">\n        <span class="lang">' +
((__t = ( l.lang )) == null ? '' : __t) +
'</span>\n        <input type="text" class="name" data-lang="' +
((__t = ( l.lang )) == null ? '' : __t) +
'" value="' +
__e( l.name ) +
'"/>\n    </div>\n    ';
 }); ;
__p += '\n    <div class="hint">' +
((__t = ( _.i18n('attributeMatching.nameHint', null, 'Shown on the webshop. An empty language falls back on the supplier\'s name.') )) == null ? '' : __t) +
'</div>\n</div>\n<div class="item">\n    <div class="libelle">' +
((__t = ( _.i18n('common.code', null, 'Code') )) == null ? '' : __t) +
'</div>\n    <input type="text" class="code" value="' +
__e( code ) +
'"/>\n    <div class="hint">\n        ' +
((__t = ( kind === 'key'
            ? _.i18n('attributeMatching.keyCodeHint', null, 'Filter code on the webshop (e.g. "Print technique" is read by the product pages). Also the code of your own attribute carrying the manual values.')
            : _.i18n('attributeMatching.valueCodeHint', null, 'Value code on the webshop (URL key of the filter).') )) == null ? '' : __t) +
'\n    </div>\n    ';
 if (renameWarning) { ;
__p += '\n    <div class="warning">' +
((__t = ( _.i18n('attributeMatching.renameWarning', null, 'Renaming changes the webshop code: republish the filters of the attribute afterwards.') )) == null ? '' : __t) +
'</div>\n    ';
 } ;
__p += '\n</div>\n';
 if (kind === 'key') { ;
__p += '\n<div class="item">\n    <label><input type="checkbox" class="show-in-filters" ';
 if (showInFilters) { ;
__p += 'checked';
 } ;
__p += '/> ' +
((__t = ( _.i18n('attributeMatching.showInFilters', null, 'Webshop filter (category pages)') )) == null ? '' : __t) +
'</label>\n    <label><input type="checkbox" class="show-in-attributes" ';
 if (showInAttributes) { ;
__p += 'checked';
 } ;
__p += '/> ' +
((__t = ( _.i18n('attributeMatching.showInAttributes', null, 'Shown in the product attributes') )) == null ? '' : __t) +
'</label>\n</div>\n';
 } else { ;
__p += '\n<div class="item param-item">\n    <div class="libelle">' +
((__t = ( _.i18n('attributeMatching.display', null, 'Display') )) == null ? '' : __t) +
'</div>\n    <label><input type="radio" name="param-type" class="param-type" value="none" ';
 if (paramType === 'none') { ;
__p += 'checked';
 } ;
__p += '/> ' +
((__t = ( _.i18n('attributeMatching.displayText', null, 'Text') )) == null ? '' : __t) +
'</label>\n    <label>\n        <input type="radio" name="param-type" class="param-type" value="color" ';
 if (paramType === 'color') { ;
__p += 'checked';
 } ;
__p += '/> ' +
((__t = ( _.i18n('attributeMatching.displayColor', null, 'Colour swatch') )) == null ? '' : __t) +
'\n        <input type="color" class="color" value="' +
((__t = ( color )) == null ? '' : __t) +
'" ';
 if (paramType !== 'color') { ;
__p += 'disabled';
 } ;
__p += '/>\n    </label>\n    <label>\n        <input type="radio" name="param-type" class="param-type" value="param" ';
 if (paramType === 'param') { ;
__p += 'checked';
 } ;
__p += '/> ' +
((__t = ( _.i18n('attributeMatching.displayParam', null, 'Parameter (e.g. image file)') )) == null ? '' : __t) +
'\n        <input type="text" class="param" value="' +
__e( param ) +
'" ';
 if (paramType !== 'param') { ;
__p += 'disabled';
 } ;
__p += '/>\n    </label>\n</div>\n';
 } ;
__p += '\n';

}
return __p
};});

